import { useSearchParams } from 'react-router-dom';
import { delegateLoginUrl, googleLoginUrl } from '../lib/api';

export function LoginPage() {
  const [params] = useSearchParams();
  const error = params.get('error');
  const messages: Record<string, string> = {
    google_denied: 'คุณยกเลิกการอนุญาต Google กรุณาลองใหม่เมื่อพร้อม',
    refresh_token_missing: 'Google ไม่ส่ง Refresh Token กรุณาถอนสิทธิ์แอปในบัญชี Google แล้วเชื่อมต่อใหม่',
    session: 'ไม่สามารถตรวจสอบเซสชันได้ กรุณาเข้าสู่ระบบใหม่',
  };
  return (
    <main className="flex min-h-screen items-center justify-center bg-gradient-to-b from-teal-50 to-slate-50 p-5">
      <section className="w-full max-w-md rounded-3xl border border-white bg-white p-6 shadow-xl shadow-teal-900/10 sm:p-8">
        <img src="/icon.svg" alt="" className="mx-auto h-20 w-20 rounded-3xl shadow-lg" />
        <h1 className="mt-6 text-center text-2xl font-bold text-slate-900">KW Workspace</h1>
        <p className="mt-2 text-center leading-relaxed text-slate-600">
          ศูนย์งาน นัดหมาย การประชุม และเอกสาร
        </p>
        {error && <p role="alert" className="mt-5 rounded-xl bg-amber-50 p-3 text-sm text-amber-900">{messages[error] ?? 'เข้าสู่ระบบไม่สำเร็จ กรุณาลองใหม่'}</p>}
        <a href={googleLoginUrl()} className="btn-primary mt-6 w-full gap-3">
          <span className="rounded-full bg-white px-2 py-0.5 font-bold text-blue-600">G</span>
          เข้าสู่ระบบด้วย Google
        </a>
        <a href={delegateLoginUrl()} className="btn-secondary mt-3 w-full gap-3">
          เข้าสู่ระบบเพื่อช่วยลงนัดเท่านั้น
        </a>
        <p className="mt-2 text-center text-xs text-slate-500">ทางเข้านี้ขอเพียงข้อมูลบัญชี Google และใช้ได้หลังเจ้าของเพิ่มอีเมลของคุณ</p>
        <p className="mt-5 text-center text-xs leading-relaxed text-slate-500">
          ทางเข้าปกติขอสิทธิ์จัดการปฏิทินของบัญชีคุณ ส่วนทางเข้าผู้ช่วยขอเพียงข้อมูลบัญชี ไฟล์เอกสารจะไม่เปิดเผยสาธารณะ
        </p>
      </section>
    </main>
  );
}
